import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import {
  ApartmentOutlined,
  PeopleAltOutlined,
  Inventory2Outlined,
  BrandingWatermarkOutlined,
} from "@mui/icons-material";
import { tokens, radius } from "../theme/theme";
import { CHROME } from "../public/halloween/season";

export default function BarTabs({
  listObjects,
  listClients,
  listArchives,
  openWatermark,
  admin,
}) {
  const [value, setValue] = React.useState("objects");

  const handleChange = (event, newValue) => setValue(newValue);

  const tabSx = CHROME
    ? {
        minHeight: 44,
        px: 2,
        borderRadius: radius.pill,
        color: "rgba(255,255,255,0.72)",
        "&:hover": { color: "#fff" },
        "&.Mui-selected": {
          color: CHROME.accentText,
          backgroundColor: CHROME.accentBg,
        },
      }
    : {
        minHeight: 44,
        px: 2,
        borderRadius: radius.pill,
        color: tokens.ink500,
        "&.Mui-selected": { color: tokens.blue700, backgroundColor: tokens.blue50 },
      };

  return (
    <Box sx={{ minWidth: 0 }}>
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        TabIndicatorProps={{ style: { display: "none" } }}
        sx={{
          minHeight: 44,
          ...(CHROME
            ? { "& .MuiTabs-scrollButtons": { color: "rgba(255,255,255,0.8)" } }
            : {}),
        }}
      >
        <Tab
          value="objects"
          label="Об'єкти"
          icon={<ApartmentOutlined sx={{ fontSize: 18 }} />}
          iconPosition="start"
          sx={tabSx}
          onClick={() => listObjects(null)}
        />
        <Tab
          value="clients"
          label="Клієнти"
          icon={<PeopleAltOutlined sx={{ fontSize: 18 }} />}
          iconPosition="start"
          sx={tabSx}
          onClick={() => listClients(null)}
        />
        {admin && (
          <Tab
            value="archives"
            label="Архів"
            icon={<Inventory2Outlined sx={{ fontSize: 18 }} />}
            iconPosition="start"
            sx={tabSx}
            onClick={() => listArchives(null)}
          />
        )}
        <Tab
          value="watermark"
          label="Лого на фото"
          icon={<BrandingWatermarkOutlined sx={{ fontSize: 18 }} />}
          iconPosition="start"
          sx={tabSx}
          onClick={() => openWatermark()}
        />
      </Tabs>
    </Box>
  );
}
